<template>
  <div>
    <loading :active="isLoading" :can-cancel="false" :is-full-page="fullPage"></loading>
    <div class="navbar-lower navbar-fixed">
      <menu-horizontal></menu-horizontal>
    </div>
    <cook-logo v-if="!empresaExiste"></cook-logo>
    <div v-else>
      <nav-bar></nav-bar>
      <logo-empresa></logo-empresa>
      <informacoes-empresa></informacoes-empresa>
       <div v-if="this.$store.state.produtosDestaque.length > 0" class="container" style="margin-top: 8px">
          <titulo-destacado class="lb-grupo " :titulo="titulodestaque"></titulo-destacado>
          <div class="row">
              <card style="margin-top: 10px"
                v-for="destaque in this.$store.state.produtosDestaque"
                :produto="destaque"
                :em-promocao="true"
                :key="'itempromocao-' + destaque.id"
              ></card>
          </div>
      </div>
       <div class="container" style="margin-top: 8px">
        <div v-for="grupo in this.$store.state.grupos" :key="grupo.id" :id="'grupo-' + grupo.id" class="scrollspy grupo-scroll"  v-if="grupo.produtos.length > 0">
            <titulo-destacado class="lb-grupo " :titulo="grupo.nome.toLocaleUpperCase()"></titulo-destacado>
            <div class="itemb">
              <p >
                {{ grupo.descricao }}
              </p>
            </div>
            <item class="" v-for="produto in grupo.produtos" :id="'produtoid-'+produto.id" :key="produto.id" :produto="produto" :grupo="grupo.nome.toLocaleUpperCase()"></item>
        </div>
      </div>
      <meu-pedido-bloco-flutuante-component></meu-pedido-bloco-flutuante-component>
      <meu-login-bloco-flutuante-component></meu-login-bloco-flutuante-component>
    </div>
    <modal-repetir-pedido></modal-repetir-pedido>
  </div>
</template>

<script>
  import MeuPedidoBlocoFlutuanteComponent from "../Widgets/MeuPedidoBlocoFlutuanteComponent";
  import Loading from 'vue-loading-overlay';
  import 'vue-loading-overlay/dist/vue-loading.css';
  import axios from 'axios';
  import CookLogo from "../Widgets/CookLogo";
  import TituloDestacado from "../Widgets/TituloDestacado";
  import NavBar from "../Widgets/NavBar";
  import Item from "../Widgets/Item";
  import LogoEmpresa from "../Widgets/LogoEmpresa";
  import InformacoesEmpresa from "../Widgets/InformacoesEmpresa";
  import MenuHorizontal from "../Widgets/MenuHorizontal";
  import MeuLoginBlocoFlutuanteComponent from "../Widgets/MeuLoginBlocoFlutuanteComponent";
  import ModalRepetirPedido from "../Widgets/ModalRepetirPedido.vue";
  import {ObterClienteLogado} from "../../services/auth";
  import Card from "../Card";

  export default {
    name: "Cardapio",
    data(){
      return {
        grupos:this.$store.state.grupos,
        produtosDestaque:this.$store.state.produtosDestaque,
        empresaExiste: false,
        isLoading: false,
        fullPage: true,
        titulodestaque: this.$store.state.empresa.titulo_destaque
      }
    },
    mounted()
    {

      if (this.$store.state.empresa_url == this.$router.currentRoute.params.empresa && this.$store.state.grupos.length > 0){
        this.titulodestaque = this.$store.state.empresa.titulo_destaque
        this.empresaExiste = true;
      }else{
        this.VerificarEmpresa().then(()=>{
          this.titulodestaque = this.$store.state.empresa.titulo_destaque
          if(this.$store.state.pedido.itens.length == 0){
            this.ObterUltimoPedido();
          }
        });
      }


      $(window).scroll(function() {
        var scroll = $(window).scrollTop();

        if (scroll >= 100) {
          $(".navbar-lower").show();
          $(".navbar-lower").addClass("navbar-fixed");
          if(document.getElementById("menulateralIcone")){
            document.getElementById("menulateralIcone").style = "display:block;"
          }
          if(document.getElementById("menulateralIcone2")){
            document.getElementById("menulateralIcone2").style = "display:block;"
          }

          var elem = document.querySelector('.sidenav');
          var instance = M.Sidenav.init(elem, {
            onOpenStart: function () {
              document.getElementById("nav-grupo-conteiner").style = "display:none;"

            },
            onCloseEnd: function () {
              document.getElementById("nav-grupo-conteiner").style = "display:block;"
            }
          });
        }
        else {
          $(".navbar-lower").removeClass("navbar-fixed");
          $(".navbar-lower").hide();
          if(document.getElementById("menulateralIcone")){
            document.getElementById("menulateralIcone")
          }
          if(document.getElementById("menulateralIcone2")){
            document.getElementById("menulateralIcone2").style = "display:none;"
          }


        }
        $('.grupo-scroll').each(function(i) {
          if ($(this).position().top <= (scroll + 140)) {
            $('.nav-grupo-conteiner a.active').removeClass('active');
            $('.nav-grupo-conteiner a').eq(i).addClass('active');
            document.getElementById("nav-grupo-conteiner").scrollLeft += ($('.nav-grupo-conteiner a.active').position().left - 30)
          }
        });
      }).scroll();


      $('.materialboxed').materialbox();

      setTimeout(function(){
       $("body").css({"overflow":"unset"});
      }, 1000);


    },
    updated() {
      try {
        if (this.$route.query.produto) {
          const divElement = document.getElementById('produtoid-' + this.$route.query.produto);
          if (divElement) {
            this.$router.replace("/" + this.$store.state.empresa_url + "/menu");
            divElement.click();
          }
        }
      } catch (exception) {
      }
    },
    components: {
        MeuLoginBlocoFlutuanteComponent,
        MenuHorizontal,
        InformacoesEmpresa,
        LogoEmpresa,
        Item,
        NavBar,
        TituloDestacado,
        CookLogo,
        MeuPedidoBlocoFlutuanteComponent,
        Loading,
        ModalRepetirPedido,
        Card
    },
    methods:{
      async VerificarEmpresa()
      {
        this.isLoading = true;
        this.$store.commit('empresaUrl', this.$router.currentRoute.params.empresa);
        await axios.get(this.$store.state.apiUrl + 'empresa/' + this.$store.state.empresa_url)
        .then(res => {
          if(res.data) {
            this.isLoading = false;
            this.$store.commit('empresa', res.data);
            this.empresaExiste = true;
          }
        })
        .catch(error => this.isLoading = false);

        if(this.empresaExiste){
            this.obterGruposEProdutos();
            this.obterProdutosEmDestaque();
        }
        else
          this.$router.push('/404/nao-localizado');
      },
      obterGruposEProdutos()
      {
        this.isLoading = true;
        let link = '';
        try{
          if(this.$store.state.empresa.usar_multilink_24hrs == 'S'){
            if(this.$route.query.link){
              link = '?link='+this.$route.query.link;
              this.$store.state.multilink_ativo = true;
              this.$store.state.empresa.aberto = "S";
            }
          }else{
            if(this.$route.query.link){
              link = '?link='+this.$route.query.link;
            }
            this.$store.state.multilink_ativo = false;
          }
          if (link != '') {
            this.$store.state.url_multilink = link; //this.$store.state.apiUrl.replace('/api','/'+this.$store.state.empresa_url+'/menu')+
          }
        }catch(exception){}
        axios.get(this.$store.state.apiUrl + 'empresa/' + this.$store.state.empresa_url + '/grupos/produtos' + link)
        .then(res => {
          this.$store.commit('grupos', res.data)
          this.$store.commit('produtosPromocao', res.data.promocoes)
          this.grupos = res.data;
          this.isLoading = false;
        })
        .catch(error=> this.isLoading = false);
      },
      obterProdutosEmDestaque()
      {
        this.isLoading = true;
        let link = '';
        try{
          if(this.$store.state.empresa.usar_multilink_24hrs == 'S'){
            if(this.$route.query.link){
              link = '?link='+this.$route.query.link;
              this.$store.state.multilink_ativo = true;
              this.$store.state.empresa.aberto = "S";
            }
          }else{
            if(this.$route.query.link){
              link = '?link='+this.$route.query.link;
            }
            this.$store.state.multilink_ativo = false;
          }
          if (link != '') {
            this.$store.state.url_multilink = link; //this.$store.state.apiUrl.replace('/api','/'+this.$store.state.empresa_url+'/menu')+
          }
        }catch(exception){}
        axios.get(this.$store.state.apiUrl + 'empresa/' + this.$store.state.empresa_url + '/grupos/produtos/destaque' + link)
        .then(res => {
          this.$store.commit('produtosDestaque', res.data)
          this.produtosDestaque = res.data;
          this.isLoading = false;
        })
        .catch(error=> this.isLoading = false);
      },
      async ObterUltimoPedido() {
      this.isLoading = true;

      try {
        let cliente = await ObterClienteLogado();
        if (!cliente || !cliente.telefone || !this.$store.state.exibir_popup_ultimo_pedido) {
          this.isLoading = false;
          return;
        }

        const { data: response } = await axios.post(this.$store.state.apiUrl + "cliente/ultimo-pedido", {
          empresaId: this.$store.state.empresa.id,
          telefone: cliente.telefone
        });

        if (response && response.pedido != null) {
          this.$store.state.ultimo_pedido_cliente_logado = response.pedido;
          this.$store.state.exibir_popup_ultimo_pedido = false;
          $('#ModalRepetirPedido').modal('open');
        }
      } catch (err) {
        console.error("Erro em ObterUltimoPedido:", err.response ? err.response.data : err.message);
      } finally {
        this.isLoading = false;
      }
    },
    },
  }

</script>

<style>

.sidenav-overlay {
  position: fixed !important;
  top: 0 !important;
  left: 0 !important;
  right: 0 !important;
  opacity: 0 !important;
  height: 120vh !important;
  background-color: rgba(0, 0, 0, 0.5) !important;
  z-index: 0 !important;
  display: none !important;
}
.grupo-scroll > .lb-grupo + .card {
  margin-top: 50px; /* Defina a quantidade desejada de espaçamento aqui */
}
</style>



// WEBPACK FOOTER //
// src/components/Paginas/Cardapio.vue